import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'timeAgo',
})
export class TimeAgoPipe implements PipeTransform {
  private value: Date;
  private timer: string;

  transform(obj: any, ...args: Array<any>): any {
    this.value = new Date(obj);

    return this.timer = this.elapsed();
  }

  elapsed(): string {
    const now = new Date().getTime();

    // time since message was sent in seconds
    const delta = (now - this.value.getTime()) / 1000;

    // format string
    if (delta < 60) { // sent in last minute
      return `pre ${Math.floor(delta)}s`;
    } else if (delta < 3600) { // sent in last hour
      return `pre ${Math.floor(delta / 60)}m`;
    } else if (delta < 86400) { // sent on last day
      return `pre ${Math.floor(delta / 3600)}h`;
    } else { // sent more than one day ago
      return `pre ${Math.floor(delta / 86400)} dana`;
    }
  }
}
